import { __extends } from "tslib";
import { Tools } from "@babylonjs/core/Misc/tools";
import { Container } from "./container";
import { Control } from "./control";
import { _TypeStore } from '@babylonjs/core/Misc/typeStore';
/**
 * Class used to create a 2D stack panel container
 */

var StackPanel =
/** @class */
function (_super) {
  __extends(StackPanel, _super);
  /**
   * Creates a new StackPanel
   * @param name defines control name
   */


  function StackPanel(name) {
    var _this = _super.call(this, name) || this;

    _this.name = name;
    _this._isVertical = true;
    _this._manualWidth = false;
    _this._manualHeight = false;
    _this._doNotTrackManualChanges = false;
    /**
     * Gets or sets a boolean indicating that layou warnings should be ignored
     */

    _this.ignoreLayoutWarnings = false;
    return _this;
  }

  Object.defineProperty(StackPanel.prototype, "isVertical", {
    /** Gets or sets a boolean indicating if the stack panel is vertical or horizontal*/
    get: function get() {
      return this._isVertical;
    },
    set: function set(value) {
      if (this._isVertical === value) {
        return;
      }

      this._isVertical = value;

      this._markAsDirty();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StackPanel.prototype, "width", {
    get: function get() {
      return this._width.toString(this._host);
    },

    /**
     * Gets or sets panel width.
     * This value should not be set when in horizontal mode as it will be computed automatically
     */
    set: function set(value) {
      if (!this._doNotTrackManualChanges) {
        this._manualWidth = true;
      }

      if (this._width.toString(this._host) === value) {
        return;
      }

      if (this._width.fromString(value)) {
        this._markAsDirty();
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(StackPanel.prototype, "height", {
    get: function get() {
      return this._height.toString(this._host);
    },

    /**
     * Gets or sets panel height.
     * This value should not be set when in vertical mode as it will be computed automatically
     */
    set: function set(value) {
      if (!this._doNotTrackManualChanges) {
        this._manualHeight = true;
      }

      if (this._height.toString(this._host) === value) {
        return;
      }

      if (this._height.fromString(value)) {
        this._markAsDirty();
      }
    },
    enumerable: true,
    configurable: true
  });

  StackPanel.prototype._getTypeName = function () {
    return "StackPanel";
  };
  /** @hidden */


  StackPanel.prototype._preMeasure = function (parentMeasure, context) {
    for (var _i = 0, _a = this._children; _i < _a.length; _i++) {
      var child = _a[_i];

      if (this._isVertical) {
        child.verticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
      } else {
        child.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
      }
    }

    _super.prototype._preMeasure.call(this, parentMeasure, context);
  };

  StackPanel.prototype._additionalProcessing = function (parentMeasure, context) {
    _super.prototype._additionalProcessing.call(this, parentMeasure, context);

    this._measureForChildren.copyFrom(parentMeasure);

    this._measureForChildren.left = this._currentMeasure.left;
    this._measureForChildren.top = this._currentMeasure.top;

    if (!this.isVertical || this._manualWidth) {
      this._measureForChildren.width = this._currentMeasure.width;
    }

    if (this.isVertical || this._manualHeight) {
      this._measureForChildren.height = this._currentMeasure.height;
    }
  };

  StackPanel.prototype._postMeasure = function () {
    var stackWidth = 0;
    var stackHeight = 0;

    for (var _i = 0, _a = this._children; _i < _a.length; _i++) {
      var child = _a[_i];

      if (!child.isVisible || child.notRenderable) {
        continue;
      }

      if (this._isVertical) {
        if (child.top !== stackHeight + "px") {
          child.top = stackHeight + "px";
          this._rebuildLayout = true;
          child._top.ignoreAdaptiveScaling = true;
        }

        if (child._height.isPercentage && !child._automaticSize) {
          if (!this.ignoreLayoutWarnings) {
            Tools.Warn("Control (Name:" + child.name + ", UniqueId:" + child.uniqueId + ") is using height in percentage mode inside a vertical StackPanel");
          }
        } else {
          stackHeight += child._currentMeasure.height + child.paddingTopInPixels + child.paddingBottomInPixels;
        }
      } else {
        if (child.left !== stackWidth + "px") {
          child.left = stackWidth + "px";
          this._rebuildLayout = true;
          child._left.ignoreAdaptiveScaling = true;
        }

        if (child._width.isPercentage && !child._automaticSize) {
          if (!this.ignoreLayoutWarnings) {
            Tools.Warn("Control (Name:" + child.name + ", UniqueId:" + child.uniqueId + ") is using width in percentage mode inside a horizontal StackPanel");
          }
        } else {
          stackWidth += child._currentMeasure.width + child.paddingLeftInPixels + child.paddingRightInPixels;
        }
      }
    }

    this._doNotTrackManualChanges = true; // Let stack panel width or height default to stackHeight and stackWidth if dimensions are not specified.
    // User can now define their own height and width for stack panel.

    var panelWidthChanged = false;
    var panelHeightChanged = false;

    if (!this._manualHeight && this._isVertical) {
      // do not specify height if strictly defined by user
      var previousHeight = this.height;
      this.height = stackHeight + "px";
      panelHeightChanged = previousHeight !== this.height || !this._height.ignoreAdaptiveScaling;
    }

    if (!this._manualWidth && !this._isVertical) {
      // do not specify width if strictly defined by user
      var previousWidth = this.width;
      this.width = stackWidth + "px";
      panelWidthChanged = previousWidth !== this.width || !this._width.ignoreAdaptiveScaling;
    }

    if (panelHeightChanged) {
      this._height.ignoreAdaptiveScaling = true;
    }

    if (panelWidthChanged) {
      this._width.ignoreAdaptiveScaling = true;
    }

    this._doNotTrackManualChanges = false;

    if (panelWidthChanged || panelHeightChanged) {
      this._rebuildLayout = true;
    }

    _super.prototype._postMeasure.call(this);
  };

  return StackPanel;
}(Container);

export { StackPanel };
_TypeStore.RegisteredTypes["BABYLON.GUI.StackPanel"] = StackPanel;